/* istanbul ignore file */
import React from 'react';
import { Typography } from '@mui/material';

const MediumHeading = ({ children }: any) => {
  return (
    <div>
      <Typography variant="h2" color="brand" display="flex" alignItems="flex-start">
        {children}
      </Typography>
    </div>
  );
};

export default MediumHeading;
